module.exports = __webpack_public_path__ + "img/ecommerce-seller.c93936f1.webp";